import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
export const CompleteMultipartVideoUploadApiSchema = {
    params: z.object({
        entityId: CornSchema,
    }),
    body: z.object({
        filename: z.string(),
        requiresStitching: z.coerce.boolean().optional(),
        startTime: z.string().datetime().optional(),
        uploadId: z.string(),
        uploadedParts: z
            .object({
            partNumber: z.number(),
            eTag: z.string(),
        })
            .array(),
    }),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema.pick({ requestActor: true }),
};
export const CompleteMultipartVideoUploadRequestSchema = CompleteMultipartVideoUploadApiSchema.params
    .merge(CompleteMultipartVideoUploadApiSchema.body)
    .merge(CompleteMultipartVideoUploadApiSchema.headers);
